/**
 * CancerScreeningAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export class CancerScreeningResultModel {
  id?: number;
  personSsn?: string;
  personName?: string;
  specimenId?: string;
  requestorSsn?: string;
  requestorName?: string;
  requestorNumber?: string;
  createDateTime?: Date;
  screeningStatus?: number;
  examinationDateTime?: Date;
  locationNumber?: string;
  companyOperatorName?: string;
  companyOperatorLocation?: string;
  examinationReason?: number;
  examinationReasonDescription?: string;
  sentDirectlyToSkrin?: boolean;
  examinationNotes?: string;
  otherActiveRequests?: boolean;
  hpvTestCreateDate?: Date;
  pathologyTestCreateDate?: Date;
  hpvTestConclusionDate?: Date;
  pathologyTestConclusionDate?: Date;
  positiveHPVResultCode?: boolean

  constructor(i: any) {
    this.id = i.id;
    this.personSsn = i.personSsn;
    this.personName = i.personName;
    this.specimenId = i.specimenId;
    this.requestorSsn = i.requestorSsn;
    this.requestorName = i.requestorName;
    this.requestorNumber = i.requestorNumber;
    this.createDateTime = i.createDateTime;
    this.screeningStatus = i.screeningStatus;
    this.examinationDateTime = i.examinationDateTime;
    this.locationNumber = i.locationNumber;
    this.companyOperatorName = i.companyOperatorName;
    this.companyOperatorLocation = i.companyOperatorLocation;
    this.examinationReason = i.examinationReason;
    this.examinationReasonDescription = i.examinationReasonDescription;
    this.sentDirectlyToSkrin = i.sentDirectlyToSkrin;
    this.examinationNotes = i.examinationNotes;
    this.otherActiveRequests = i.otherActiveRequests;
    this.hpvTestCreateDate = i.hpvTestCreateDate;
    this.pathologyTestCreateDate = i.pathologyTestCreateDate;
    this.hpvTestConclusionDate = i.hpvTestConclusionDate;
    this.pathologyTestConclusionDate = i.pathologyTestConclusionDate;
    this.positiveHPVResultCode = i.positiveHPVResultCode;
  }
}
